import request from "../../utils/request";
import { chatActions } from "../slices/chatSlice";
import { toast } from "react-toastify";

export function startChat(messages) {
    return async (dispatch) => {
        try {
            dispatch(chatActions.setLoading(true));
            const { data } = await request.post("api/chat", { messages });

            const aiRes = { role: "assistant", content: data.reply }
            dispatch(chatActions.addMessage(aiRes));
            dispatch(chatActions.setLoading(false));

        } catch (error) {
            dispatch(chatActions.setLoading(false));
            toast.error(error.response.data.message);
        }
    }
}